/*
 * TimeWindowCheckBox Messages
 *
 * This contains all the text for the TimeWindowCheckBox component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.TimeWindowCheckBox";

export default defineMessages({
  from: {
    id: `${scope}.from`,
    defaultMessage: "From",
  },
  to: {
    id: `${scope}.to`,
    defaultMessage: "to",
  },
});
